/*
 * @Author: jiangxd
 * @Date: 2021-08-04 11:24:02
 * @LastEditTime: 2021-08-04 11:44:30
 * @LastEditors: jiangxd
 * @Description:
 * @FilePath: /rs_ips_maintence/src/views/components/shopDisplaySketchMap/displayEdit/backGround.tsx
 */
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import style from './style.vue';
import colorPicker from './colorPicker.vue';
import Upload from '@/views/components/upload/upload.vue';

@Component({
  components: { Upload, colorPicker },
  mixins: [style],
})
export default class BackGroundEdit extends Vue {
  @Prop({ default: () => {} })
    value: DisplayBgData;

  @Prop({ default: () => false })
    disabled: boolean;

  data: DisplayBgData = {};

  isShowMessage = true;

  bgList = ['', '', ''];

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
  }

  @Watch('data', { deep: true })
  watchData(n) {
    this.$emit('input', n);
  }

  mounted() {
    this.bgList[this.value.desc.type] = this.value.desc.val;
  }

  //   切换选择背景
  chooseBgType(val, value: DisplayBgData) {
    this.data.desc.val = this.bgList[val];
    this.isShowMessage = false;
  }

  /**
   * 背景颜色改变时
   * @param {val}
   */
  bgColorChange(val) {
    this.bgList[1] = val;
  }

  /**
   * 上传背景图片成功回调
   * @param {val}
   */
  uploadSuccess(res: HttpAPIRetItem<any>) {
    this.data.desc.val = res.content;
    this.bgList[2] = res.content;
  }

  render(h) {
    return (
      <div class="background-center">
        <p class="title">背景</p>
        <el-form props={{ model: this.data }} label-width="0" ref="form" show-message={this.isShowMessage} key={this.data.sort} label-position="top" disabled={this.disabled}>
          <el-radio-group v-model={this.data.desc.type} onChange={val => this.chooseBgType(val, this.data)}>
            <el-radio label={1}>使用纯色</el-radio>
            <el-radio label={2}>使用图片</el-radio>
          </el-radio-group>
          <el-form-item
            prop={'desc.val'}
            class="r-mt-16"
            rules={{
              required: true,
              message: `请${this.data.desc.type == 1 ? '选择颜色' : '上传图片'}`,
              trigger: ['blur', 'change'],
            }}>
            {this.data.desc.type == 1 && <colorPicker v-model={this.data.desc.val} onChange={this.bgColorChange.bind(this)} disabled={this.disabled} />}
            {this.data.desc.type == 2 && (
              <div class="cont no-scroll">
                <Upload noDelete={false} onImgUploadSuccess={val => this.uploadSuccess(val)} img={this.data.desc.val} maxSize={300} />
              </div>
            )}
          </el-form-item>
          {this.data.desc.type == 2 && (
            <p class="tip blockTip" style="margin-top:10px">
              注1：&nbsp;建议图片分辨率为750px*400px,不超过300K;
            </p>
          )}
          {this.data.desc.type == 2 && <p class="tip blockTip">注2：&nbsp;支持jpg、png、gif格式图片;</p>}
          <el-form-item label="文字颜色" prop="desc.color" rules={{ required: true, message: '请选择文字颜色', trigger: 'change' }}>
            <colorPicker v-model={this.data.desc.color} disabled={this.disabled} />
          </el-form-item>
        </el-form>
      </div>
    );
  }
}
